import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { ThemeProvider } from '@/contexts/ThemeContext';
import AuthPage from '@/pages/AuthPage';
import ClientsPage from '@/pages/ClientsPage';
import ClientDetailPage from '@/pages/ClientDetailPage';
import PartnersPage from '@/pages/PartnersPage';
import PeriodsPage from '@/pages/PeriodsPage';
import AnnouncementsPage from '@/pages/AnnouncementsPage';
import ProfilePage from '@/pages/ProfilePage';
import ReportsPage from '@/pages/ReportsPage';
import AuditPage from '@/pages/AuditPage';
import ClientPortalPage from '@/pages/ClientPortalPage';
import '@/App.css';

function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const handleLogin = (token, user) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    setToken(token);
    setUser(user);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setUser(null);
  };

  const isAdmin = user?.role === 'admin';

  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          {/* Portal do Cliente (público) */}
          <Route path="/consulta/:token" element={<ClientPortalPage />} />
          
          {/* Auth */}
          <Route
            path="/auth"
            element={!token ? <AuthPage onLogin={handleLogin} /> : <Navigate to="/clientes" />}
          />
          
          {/* Main redirect */}
          <Route
            path="/"
            element={<Navigate to="/clientes" />}
          />
          
          {/* Clients */}
          <Route
            path="/clientes"
            element={token ? <ClientsPage user={user} onLogout={handleLogout} /> : <Navigate to="/auth" />}
          />
          <Route
            path="/client/:clientId"
            element={token ? <ClientDetailPage user={user} onLogout={handleLogout} /> : <Navigate to="/auth" />}
          />
          
          {/* Admin only routes */}
          <Route
            path="/parceiros"
            element={token && isAdmin ? <PartnersPage user={user} onLogout={handleLogout} /> : <Navigate to="/clientes" />}
          />
          <Route
            path="/periodos"
            element={token && isAdmin ? <PeriodsPage user={user} onLogout={handleLogout} /> : <Navigate to="/clientes" />}
          />
          <Route
            path="/relatorios"
            element={token && isAdmin ? <ReportsPage user={user} onLogout={handleLogout} /> : <Navigate to="/clientes" />}
          />
          <Route
            path="/auditoria"
            element={token && isAdmin ? <AuditPage user={user} onLogout={handleLogout} /> : <Navigate to="/clientes" />}
          />
          
          {/* Shared routes */}
          <Route
            path="/comunicados"
            element={token ? <AnnouncementsPage user={user} onLogout={handleLogout} /> : <Navigate to="/auth" />}
          />
          <Route
            path="/perfil"
            element={token ? <ProfilePage user={user} onLogout={handleLogout} /> : <Navigate to="/auth" />}
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </ThemeProvider>
  );
}

export default App;